<div class="screen-list {{mode}}">
	<div class="title" [ngStyle]="{'opacity':opacity}" [ngClass]="{'darkTitle':hasParameter('darkTitle'),'darkerTitle':hasParameter('darkerTitle')}">{{title|uppercase}}</div>
	<div class="list" [ngStyle]="{'top':top}">
		<div 
		*ngFor="let item of getDictionary()" 
		class="list-item {{getLineClass(item)}}" 
		>
			<span class="key" [ngClass]="getClasses()">{{translator.tr(item.key)}}</span>
			<span class="value" [ngClass]="getClasses()">{{item.value}}</span>
		</div>
	</div>
</div>	